module.exports = __webpack_public_path__ + "img/empty_skills_icon.2206a988.svg";